import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "scrollable-panel__wrapper",
  ref: "scrollWrapper"
}
const _hoisted_2 = { class: "scrollable-panel" }
const _hoisted_3 = { class: "scrollable-panel__left" }
const _hoisted_4 = { class: "scrollable-panel__col__header start" }
const _hoisted_5 = { class: "scrollable-panel__col__body start" }
const _hoisted_6 = { class: "scrollable-panel__center" }
const _hoisted_7 = { class: "scrollable-panel__col__header center" }
const _hoisted_8 = { class: "scrollable-panel__col__body center" }
const _hoisted_9 = { class: "scrollable-panel__right" }
const _hoisted_10 = { class: "scrollable-panel__col__header end" }
const _hoisted_11 = { class: "scrollable-panel__col__body end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "left-panel-header", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _renderSlot(_ctx.$slots, "left-panel-body", {}, undefined, true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "center-panel-header", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "center-panel-body", {}, undefined, true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _renderSlot(_ctx.$slots, "right-panel-header", {}, undefined, true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _renderSlot(_ctx.$slots, "right-panel-body", {}, undefined, true)
        ])
      ])
    ])
  ], 512))
}